var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg-' + _vm.component,{tag:"component",staticClass:"c-vector",class:'c-vector-' + _vm.component,attrs:{"title":_vm.title}})}
var staticRenderFns = []

export { render, staticRenderFns }